export const GET_LIST_ACCOUNT_BANK = 'GET_LIST_ACCOUNT_BANK'
export const GET_LIST_ACCOUNT_BANK_ERR = 'GET_LIST_ACCOUNT_BANK_ERR'

export const CREATE_ACCOUNT_BANK = 'CREATE_ACCOUNT_BANK'
export const CREATE_ACCOUNT_BANK_ERR = 'CREATE_ACCOUNT_BANK_ERR'

export const UPDATE_ACCOUNT_BANK = 'UPDATE_ACCOUNT_BANK'
export const UPDATE_ACCOUNT_BANK_ERR = 'UPDATE_ACCOUNT_BANK_ERR'

export const LOCK_ACCOUNT_BANK = 'LOCK_ACCOUNT_BANK'
export const LOCK_ACCOUNT_BANK_ERR = 'LOCK_ACCOUNT_BANK_ERR'

export const UNLOCK_ACCOUNT_BANK = 'UNLOCK_ACCOUNT_BANK'
export const UNLOCK_ACCOUNT_BANK_ERR = 'UNLOCK_ACCOUNT_BANK_ERR'

export const GET_ACCOUNT_BANK_SEARCH_USERNAME = 'GET_ACCOUNT_BANK_SEARCH_USERNAME'
export const GET_ACCOUNT_BANK_SEARCH_USERNAME_ERR = 'GET_ACCOUNT_BANK_SEARCH_USERNAME_ERR'

export const GET_ACCOUNT_BANK_SEARCH_FULLNAME = 'GET_ACCOUNT_BANK_SEARCH_FULLNAME'
export const GET_ACCOUNT_BANK_SEARCH_FULLNAME_ERR = 'GET_ACCOUNT_BANK_SEARCH_FULLNAME_ERR'

export const GET_ACCOUNT_BANK_SEARCH_INTERVAL = 'GET_ACCOUNT_BANK_SEARCH_INTERVAL'
export const GET_ACCOUNT_BANK_SEARCH_INTERVAL_ERR = 'GET_ACCOUNT_BANK_SEARCH_INTERVAL_ERR'

export const RESET_LIST_ACCOUNT_BANK = 'RESET_LIST_ACCOUNT_BANK'